module.exports = __webpack_public_path__ + "img/icon-slot-white.01c3caa5.svg";